
import React from "react";
import theme from "../../../styles/theme";

/**
 * Composant Tag réutilisable.
 * - Peut recevoir une couleur manuelle (prioritaire)
 * - Ou déduire ses couleurs depuis theme.statusColors[category][label]
 *
 * @param {string} label - Texte affiché dans le tag
 * @param {string} category - "task" | "project" | "userRole" | "userStatus"
 * @param {string} color - Couleur manuelle de fond (optionnelle)
 * @param {string} textColor - Couleur manuelle du texte (optionnelle)
 */
  const Tag = ({ label, category, color, textColor }) => {
  // Normalisation du label pour correspondre aux clés du thème
  const normalizedLabel = label && typeof label === "string" ? label.trim().replace(/\s+/g, "").toLowerCase() : "";

  // Récupération des couleurs du thème si catégorie définie
  const fromTheme =
    category && theme.statusColors?.[category] ? Object.entries(theme.statusColors[category]).find(([key]) => key.toLowerCase() === normalizedLabel)?.[1] : null;

  const bg = color || fromTheme?.bg || "#e5e7eb"; // gris clair par défaut
  const text = textColor || fromTheme?.text || "#111827"; // gris foncé par défaut

  return (
    <span
      style={{
        display: "inline-block",
        padding: "2px 8px",
        borderRadius: theme.borders.radius.xxl,
        backgroundColor: bg,
        color: text,
        fontSize: theme.fontSizes.sm,
        fontWeight: theme.fontWeights.normal,
        whiteSpace: "nowrap",
        cursor: "default",
        userSelect: "none",
        fontFamily: theme.fonts.primary,
      }}
    >
      {label}
    </span>
  );
};

export default Tag;
